import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-359d8267"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon_layout_title",
  src: "/assets/icon/meus_dados.svg"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Meus dados ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Nome")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Celular")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Data Nascimento")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Excluir conta ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Salvar ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_alert = _resolveComponent("ion-alert")!
  const _component_SafeArea = _resolveComponent("SafeArea")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_SelectDia = _resolveComponent("SelectDia")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_alert, {
        "is-open": _ctx.isOpenRef,
        header: "Ativação",
        "sub-header": "Important message",
        message: "Ativado com sucesso",
        buttons: ['OK'],
        onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOpen(false)))
      }, null, 8, ["is-open"]),
      _createVNode(_component_SafeArea, {
        onOnBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.voltar())),
        data: {'cart': false}
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "12",
                class: "ion-text-center font-montserrat layout_blue font-25"
              }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_ion_row, {
                key: 0,
                class: "ion-align-items-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center font-montserrat font-25",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_spinner, { name: "circular" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_ion_row, {
                key: 1,
                class: "ion-align-items-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "font-montserrat",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "input-cadastro",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cadastro.nome) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.cadastro.nome]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "font-montserrat",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createElementVNode("input", {
                        type: "tel",
                        class: "input-cadastro",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cadastro.celular) = $event)),
                        onMaska: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cadastro.celular_v = $event.target.dataset.maskRawValue))
                      }, null, 544), [
                        [_vModelText, _ctx.cadastro.celular],
                        [_directive_maska, ['(##)# ####-####', '(##)# ####-####']]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        disabled: true,
                        class: "input-cadastro",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cadastro.nascimento) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.cadastro.nascimento]
                      ]),
                      _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            class: "font-montserrat",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_SelectDia, {
                                "onUpdate:modelValue": _ctx.cadastro,
                                data: _ctx.cadastro
                              }, null, 8, ["onUpdate:modelValue", "data"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "font-montserrat",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _hoisted_7,
                      _hoisted_8,
                      _hoisted_9,
                      _createVNode(_component_ion_button, {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.gotoExcluir())),
                        size: "large",
                        color: "jauservecinza",
                        shape: "jau",
                        expand: "block"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }),
                      _hoisted_11,
                      (!_ctx.isEnviando)
                        ? (_openBlock(), _createBlock(_component_ion_button, {
                            key: 0,
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.save())),
                            size: "large",
                            color: "jauservelayoutalter",
                            shape: "jau",
                            expand: "block"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_ion_button, {
                            key: 1,
                            color: "jauservelayoutalter",
                            shape: "jau",
                            expand: "block"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_spinner, { name: "circular" })
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}